import ReviewPlatformsSFC from "./ReviewPlatforms.vue";
export const ReviewPlatforms = ReviewPlatformsSFC;
